// ── 매입 표 줄 끝 🗑 (2026-11-03 사용자 "제일 오른쪽에 휴지통 아이콘, 삭제 가능") ─────────
// keepFocus: 고치는 줄에서 누를 때 mousedown 을 막아, 커서가 빠지며 저장이 먼저 돌지 않게.
import React, { useState } from 'react';

export default function TrashButton({ onClick, keepFocus = false, title = '이 줄 삭제' }) {
  const [hot, setHot] = useState(false);
  return (
    <button
      type="button" title={title} aria-label={title}
      onMouseDown={keepFocus ? (e) => e.preventDefault() : undefined}
      onClick={(e) => { e.stopPropagation(); onClick?.(); }}
      onMouseEnter={() => setHot(true)} onMouseLeave={() => setHot(false)}
      style={{
        width: 32, height: 32, display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
        borderRadius: 8, cursor: 'pointer', border: 'none', padding: 0,
        background: hot ? 'rgba(239,68,68,0.12)' : 'transparent', color: hot ? '#dc2626' : 'var(--text-muted)',
      }}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <polyline points="3 6 5 6 21 6" />
        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
        <path d="M10 11v6" /><path d="M14 11v6" />
        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
      </svg>
    </button>
  );
}
